import { useApp } from "@/context/AppContext";
import { api } from "@/lib/api";
import { toast } from "sonner";

export const useSave = () => {
  const { user, setAuthOpen } = useApp();

  const save = async (item) => {
    if (!user) {
      toast("Sign in to save to your dashboard", { description: "Create your free MOVA concierge profile." });
      setAuthOpen(true);
      return false;
    }
    try {
      await api.post("/saved", item);
      toast.success("Saved to your dashboard", { description: item.title });
      return true;
    } catch (e) {
      toast.error("Could not save", { description: "Please try again." });
      return false;
    }
  };

  return { save };
};
